import { LoadingOutlined } from "@ant-design/icons";
import { Flex, Row, Spin } from "antd";
import { useEffect, useState } from "react";

import RenewCertStart from "pages/renewcert/components/step/RenewCertStart";
import RenewCertEnd from "pages/renewcert/components/step/RenewCertEnd";
import RenewCertInsertToken from "pages/renewcert/components/step/RenewCertInsertToken";
import ServiceApi from "../../apis/ServiceApi";
import { showNotification } from "../../common";
import Footer from "../../components/footer";
import Header from "./Header";
import Prefixs from "common/Prefixs";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { OBJECT_COMPENSATION } from "constants/objectCompensation";
import Api from "apis/Api";
import ActionTypes from "common/ActionTypes";
import GloabalConst from "common/GloabalConst";
import TutorialCode from "common/TutorialCode";

const ReNewCert = () => {
  const history = useHistory();
  const [statusYc, setStatusYc] = useState(0);
  const [loadingPage, setLoadingPage] = useState(false);
  const [loadingPageInfoCB, setLoadingPageInfoCB] = useState(false);
  const [loadingPageReqCB, setLoadingPageReqCB] = useState(false);
  const [dataCheckReq, setDataCheckReq] = useState({});
  const [dataInfoCert, setDataInfoCert] = useState({});
  const [isStart, setIsStart] = useState(true);

  const fetchRouter = async () => {
    try {
      setLoadingPage(true);
      const tokenFromStorage = sessionStorage.getItem("tokenGW");
      const res = await Api.getPrefixRouter(tokenFromStorage);
        if (res && res.status === 200 && res.data.data) {
          if (
            res.data.data.type === ActionTypes.REDIRECT &&
            res.data.data.linkPromotion
          ) {
          } else if (
            res.data.data.type === ActionTypes.ROUTER &&
            res.data.data.linkPromotion
          ) {
          } else {
            setIsStart(false)
            window.location.href = res.data.data.linkDefault;
          }
        }
      console.log('res: ', res);
    } catch (error) {
      setIsStart(false)
      console.error("error: ", error);
      showNotification("error", error.message, "Thông báo");
    }finally {
      setLoadingPage(false);
    }
  };

  useEffect(() => {
    localStorage.setItem(
      GloabalConst.TUTORIAL_CODE,
      TutorialCode.RENEWCERT.value
    );

    fetchRouter();

    fetchDataCert().then((value) => {
      fetchDataDetail(value);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchDataCert = async () => {
    setLoadingPageInfoCB(true);
    try {
      const res = await ServiceApi.getCertInfoCapBu();
      if (res && res.status === 200 && res.data.data) {
        setDataInfoCert(res.data.data.data);
        return res.data.data.data;
      } else {
        return null;
      }
    } catch (error) {
      console.error("error: ", error);
      showNotification("error", error.message, "Thông báo");
    } finally {
      setLoadingPageInfoCB(false);
    }
  };

  const clickChangeInfo = () => {
    history.push(`${Prefixs.SUPPORT_CHANGE_INFO}?isCompensation2025=1`);
  };
  const clickExtend = (dataCert) => {
    history.push(`${Prefixs.COMPENSATION_EXTEND}?type=${dataCert?.type}`);
  };

  const fetchDataDetail = async (dataCert) => {
    setLoadingPageReqCB(true);
    try {
      const resCheck = await ServiceApi.checkrequestcapbu();

      if (resCheck.data.status === 200) {
        if (resCheck.data.data?.status) {
          const dataDetail = resCheck.data.data;
          setDataCheckReq(dataDetail);
          const statusCheck = dataDetail.status;
          setStatusYc(statusCheck);
          if (
            [
              OBJECT_COMPENSATION.PENDING_APPROVAL,
              OBJECT_COMPENSATION.REJECT_APPROVAL,
              OBJECT_COMPENSATION.WAIT_SIGN,
            ].includes(statusCheck)
          ) {
            if (dataDetail.object === 4) {
              clickChangeInfo();
              return;
            }
            if (dataDetail.object === 2) {
              clickExtend(dataCert);
            }
          }
        }
      }
    } catch (error) {
      console.error("error: ", error);
      showNotification("error", error.message, "Thông báo");
    } finally {
      setLoadingPageReqCB(false);
    }
  };

  const renderPage = () => {
    if (statusYc < OBJECT_COMPENSATION.WAIT) {
      return (
        <>
          <RenewCertStart isStart={isStart}/>
        </>
      );
    }
    if (statusYc === OBJECT_COMPENSATION.WAIT) {
      return <RenewCertInsertToken />;
    }
    if (statusYc === OBJECT_COMPENSATION.SUCCESS) {
      return <RenewCertEnd dataCheckReq={dataCheckReq} />;
    }
  };

  return (
    <Spin
      spinning={loadingPage}
      tip="Vui lòng đợi..."
      indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
    >
      {!loadingPage && !loadingPageInfoCB && !loadingPageReqCB &&
      <Flex
        justify="center"
        align="middle"
        style={{ minHeight: "100vh", width: "1140px" }}
        className="lock-certificate-container container"
      >
        <Header />
        {renderPage()}
        <Footer />
      </Flex>
      }
    </Spin>
  );
};

export default ReNewCert;
